import React from 'react'
import WalletHistory from './Wallet/WalletHistory';

const Tnc = () => {
  return (
    <div className="container my-5 p-4 bg-white rounded shadow-lg">
      <div className="text-center mb-4">
        <h1 className="text-3xl font-bold text-red-600">💥 888 Solution 💥</h1>
      </div>

      <div className="space-y-4 text-gray-800 text-lg">
        <p>🔥 <strong>10 Rs एकल जोड़ी भुगतान = 980 Rs</strong> 🔥</p>
        <p>🔥 <strong>10 Rs हुर्रफ (A.B.) भुगतान = 98 Rs</strong> 🔥</p>
        <p>🔥 भुगतान जमा करने का समय: <strong>24x7</strong> 🔥</p>
        <p className="text-center font-semibold text-blue-700">👽 गेम कैसे खेलनी है जानिए 👽</p>
        <p>(हरुफ आप 6×6 से ज्यादा प्ले नहीं कर सकते)</p>

        <div className="border-t border-gray-300 pt-4 space-y-3">
          <p>
            <strong>दिसावर :</strong> 500 रूपये की जोड़ी व 1000 रूपये तक का हरुफ़ रात 12.00 AM तक उसके बाद 100 रूपये तक की ही जोड़ी व 200 रूपये तक हरुफ़ मान्य रहेगा /- अन्यथा हमारी कोई जिम्मेदारी नही होगी !
          </p>

          <p>
            <strong>गली :</strong> 500 रूपये की जोड़ी व 1000 रूपये तक का हरुफ़ रात 10.15 PM तक उसके बाद 100 रूपये तक की ही जोड़ी व 200 रूपये तक हरुफ़ मान्य रहेगा /- अन्यथा हमारी कोई जिम्मेदारी नही होगी !
          </p>

          <p>
            <strong>गाजियाबाद :</strong> 500 रूपये की जोड़ी व 1000 रूपये तक का हरुफ़ शाम 7.15 PM तक उसके बाद 100 रूपये तक की ही जोड़ी व 200 रूपये तक हरुफ़ मान्य रहेगा /- अन्यथा हमारी कोई जिम्मेदारी नही होगी !
          </p>

          <p>
            <strong>फरीदाबाद :</strong> 500 रूपये की जोड़ी व 1000 रूपये तक का हरुफ़ शाम 4.45 PM तक उसके बाद 100 रूपये तक की ही जोड़ी व 200 रूपये तक हरुफ़ मान्य रहेगा /- अन्यथा हमारी कोई जिम्मेदारी नही होगी !
          </p>

          <p>
            <strong>दिल्ली बाजार :</strong> 500 रूपये की जोड़ी व 1000 रूपये तक का हरुफ़ दोपहर 1.45 PM तक उसके बाद 100 रूपये तक की ही जोड़ी व 200 रूपये तक हरुफ़ मान्य रहेगा /- अन्यथा हमारी कोई जिम्मेदारी नही होगी !
          </p>
        </div>
      </div>
    </div>
  );
};

export default Tnc;
